
import { defineComponent, ref, onMounted, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("抽签签池", ["抽签签池;lottery_signs"]);
    });

    const store = useStore();
    const router = useRouter();
    const tableData = ref([]);

    const formData = ref({
      name: "",
      enabled: "",
    });

    const enabledWeightTotal = computed(() => {
      return tableData.value
        .filter((s: any) => s.enabled)
        .reduce((sum: number, s: any) => sum + Number(s.weight || 0), 0);
    });

    const probability = (row: any) => {
      if (!row.enabled) return "—";
      const total = enabledWeightTotal.value;
      if (!total) return "—";
      return ((Number(row.weight) / total) * 100).toFixed(2) + "%";
    };

    const query = () => {
      const params: Record<string, unknown> = {
        ...formData.value,
      };
      store
        .dispatch(Actions.GET_LOTTERY_SIGNS, params)
        .then(() => {
          tableData.value = store.getters.currentLotterySigns;
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {});
    };

    query();

    const newLotterySign = () => {
      router.push({ name: "lottery_sign_new" });
    };

    const onSearch = () => {
      query();
    };

    const onReset = () => {
      formData.value.name = "";
      formData.value.enabled = "";
      query();
    };

    const onDelete = (id) => {
      Swal.fire({
        title: "确认删除？",
        text: "已有抽签记录的签无法删除，建议改为停用",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_LOTTERY_SIGN, id)
            .then(() => {
              query();
            })
            .catch((errorMsg) => {
              Swal.fire({
                text: errorMsg || "删除失败",
                icon: "error",
                confirmButtonText: "确认",
              });
            });
        }
      });
    };

    return {
      tableData,
      formData,
      newLotterySign,
      probability,
      onSearch,
      onReset,
      onDelete,
    };
  },
});
